'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgRefresh } from '@common/icon';
interface FilterSidebarShellProps {
  onReset: () => void;
  children: React.ReactNode;
}
export function FilterSidebarShell(t0) {
  const $ = _c(8);
  const {
    onReset,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 text-Gray-900 typo-body3">필터</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgRefresh className="size-14 text-Gray-600" />;
    t3 = <span className="font-700 text-Gray-600 typo-body4">초기화</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onReset) {
    t4 = <div className="flex items-center justify-between px-12">{t1}<button type="button" className="flex h-40 items-center justify-center gap-4 py-8" onClick={onReset}>{t2}{t3}</button></div>;
    $[3] = onReset;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <aside className="block w-202 shrink-0 self-stretch px-24 mobile-tablet:hidden"><div className="sticky top-80 flex max-h-[calc(100dvh-80px)] flex-col gap-24 overflow-y-auto pb-24">{t4}{children}</div></aside>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}